/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LoanListPage = lazyLoad(
  () => import('./index'),
  module => module.LoanListPage,
);
